import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PLENARY_DOCS_STATUS, PLENARY_DOCS_TYPES } from 'src/app/enums/enums';
import { PlenaryDoc } from 'src/app/models/plenary-docs.model';
import { PlenaryDocsService } from 'src/app/services/plenary-docs.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserService } from 'src/app/services/user.service';
declare var $: any;

@Component({
  selector: 'app-informes-plenaria',
  templateUrl: './informes-plenaria.component.html',
  styleUrls: ['./informes-plenaria.component.css']
})
export class InformesPlenariaComponent implements OnInit {
  public plenaryDocs:   PlenaryDoc[] = [];
  public status:        string;
  public identity:      string;
  public token:         string;
  public plenaryDoc:    PlenaryDoc;
  public form:          FormData = new FormData();
  public loading:       boolean = false;
  public isSubmitting:  boolean = false;
  public isDeleting:    boolean = false;
  public isUpdating:    boolean = false;
  public page:          number = 1;
  public pageSize:      number = 10;
  public filename:      string;
  public docTypes:      string[] = [
    PLENARY_DOCS_TYPES.PRONOUNCEMENTS,
    PLENARY_DOCS_TYPES.RESOLUTIONS,
    PLENARY_DOCS_TYPES.DECLARATIONS,
    PLENARY_DOCS_TYPES.REPORTS,
    PLENARY_DOCS_TYPES.PROCEEDINGS,
  ];

  constructor(
    private _plenaryDocsService:  PlenaryDocsService,
    private _storageService:      StorageService,
    private _userService:         UserService,
    private _router:              Router,
    protected _sanitizer:         DomSanitizer,
  ) {
    this.cleanDoc();
  }

  ngOnInit(): void {
    $('html,body').scrollTop(0);
    this.identity = this._userService.getIdentity();
    this.token    = this._userService.getToken();
    if (!this.identity || !this.token) {
      this._router.navigate(['/iniciar-sesion']);
    } else {
      this.listarDocumentos();
    }
  }

  listarDocumentos(): void {
    this.loading = true;
    this._plenaryDocsService.getDocumentsForAdmin().subscribe(
      res => {
        if (!res.documents?.length) {
          this.plenaryDocs = [];
          this.status = 'error';
        } else {
          this.plenaryDocs = res.documents;
          this.plenaryDocs = this.sortArray(this.plenaryDocs);
          this.status = 'ok';
        }
        this.loading = false;
      },
      err => this.onError(err)
    );
    
  }

  sortArray(array: any[]): any[] {
    return array.sort((a, b) => (b.year.toString()).localeCompare(a.year.toString()));
  }

  setDoc(doc: PlenaryDoc): void {
    this.plenaryDoc = doc;
  }

  agregarDocumento(): void {
    if (
      !this.plenaryDoc.title ||
      !this.plenaryDoc.name ||
      !this.plenaryDoc.year ||
      !this.plenaryDoc.description
      || !this.form.get('document')
    ) {
      return alert('Por favor, rellene los campos obligatorios');
    }
    this.isSubmitting = true;
    this._storageService.uploadFile('parliament-docs', this.filename, this.form.get('document')).then(fileUrl => {
      this.plenaryDoc.document = fileUrl;
      this._plenaryDocsService.addDocument(this.plenaryDoc).subscribe(
        res => {
          if (!res.document) {
            this.status = 'error';
          } else {
            this.plenaryDocs.push({ ...res.document });
            this.status = 'ok';
            this.cleanDoc();
          }
          this.isSubmitting = false;
        },
        err => this.onError(err)
      );
    }).catch(err => this.onError(err));
  }

  eliminarDocumento(): void {
    this.isDeleting = true;
    this._storageService.deleteFileByUrl(this.plenaryDoc.document).then(() => {
      this._plenaryDocsService.deleteDocument(this.plenaryDoc.id).subscribe(
        res => {
          alert(res.message);
          this.isDeleting = false;
          this.listarDocumentos();
          this.cleanDoc();
        },
        err => this.onError(err)
      );
    }).catch(err => this.onError(err));
  }

  actualizarDocumento(): void {
    if (!this.plenaryDoc.name || !this.plenaryDoc.title || !this.plenaryDoc.year || !this.plenaryDoc.type) {
      return alert('Por favor, rellene los campos obligatorios');
    }
    this.isUpdating = true;
    let promiseToResolve = [];
    let promiseToResolveAdd = [];
    if (this.filename) {
      promiseToResolve.push(this._storageService.deleteFileByUrl(this.plenaryDoc.document));
      promiseToResolveAdd.push(this._storageService.uploadFile('parliament-docs', this.filename, this.form.get('document')));
    }
    Promise.all(promiseToResolve).then(() => {
      Promise.all(promiseToResolveAdd).then(urlArray => {
        this.plenaryDoc.document = urlArray[0];
        this._plenaryDocsService.updateDocument(this.plenaryDoc).subscribe(
          res => {
            if (!res.document) {
            this.status = 'error';
          } else {
            this.listarDocumentos();
            this.cleanDoc();
            this.status = 'ok';
          }
          this.isUpdating = false;
        },
        err => this.onError(err)
        );
      }).catch(err => this.onError(err));
    }).catch(err => this.onError(err));
  }

  onFileChange(e: any, idx: number) {
    if (e.target.files.length > 0) {
      for (let i = 0; i < e.target.files.length; i++) {
        this.filename = e.target.files[i].name;
        $('#add-doc-label').html(this.filename);
        $('#update-doc-label').html(this.filename);
        this.form.delete('document');
        this.form.append('document', e.target.files[i], this.filename);
      }
    }
  }

  cleanDoc() {
    this.plenaryDoc = new PlenaryDoc('', '', '', '', '1900', PLENARY_DOCS_TYPES.RESOLUTIONS, PLENARY_DOCS_STATUS.ACTIVE, '');
    this.filename = ''
    this.form.delete('document');
    $('#add-doc-label').html('Buscar Documento');
    $('#update-doc-label').html('Buscar Documento');
  }

  onError(error: any): void {
    let errorMessage = error;
    alert("Error al ejecutar la acción");
    if (errorMessage != null) {
      this.status = 'error';
    }
    this.loading = false;
    this.isSubmitting = false;
    this.isDeleting = false;
    this.isUpdating = false;
  }

  cleanURLResource(oldURL: string): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(oldURL);
  }

  cleanURL(oldURL: string): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustUrl(oldURL);
  }
}
